(function () {
  var roots = document.querySelectorAll('[data-klairs-skin-fortune-v5]');
  if (!roots.length) return;

  document.body.classList.add('klairs-skin-fortune-v5-page');
  suppressRewardOverlays();
  window.setTimeout(suppressRewardOverlays, 800);
  window.setTimeout(suppressRewardOverlays, 2400);
  if (window.MutationObserver) {
    new MutationObserver(suppressRewardOverlays).observe(document.body, { childList: true, subtree: true });
  }

  var STORAGE_PREFIX = 'klairsSkinFortuneV5';
  var REVEAL_THRESHOLD = 68;
  var progressBuckets = [15, 35, 55, 68];

  var skinSigns = [
    'The Calm Drop',
    'The Quiet Barrier',
    'The Slow Glow',
    'The Bright Dew',
    'The Reset',
    'The Blue Pause',
    'The Soft Shield',
    'The Fresh Start'
  ];

  var careSigns = [
    'Layer lightly today.',
    'Let your skin rest.',
    'Prep before you treat.',
    'Hydrate, then pause.',
    'Keep the routine quiet.',
    'Choose comfort first.',
    'Press, do not rush.',
    'Seal the simple steps.'
  ];

  var fortunes = [
    'Today favors doing less.',
    'A slower routine suits your skin today.',
    'Good day to keep it simple.',
    'Your glow likes patience today.',
    'The calm step is the lucky step.',
    'A gentle rhythm wins today.',
    'Let your routine breathe.',
    'Small care, repeated well, is the signal.',
    'Your skin sign points toward comfort.',
    'A quiet night routine has good luck.'
  ];

  var missions = [
    'Do your PM steps before 11pm.',
    'Add one hydration layer today.',
    'Patch test before you commit.',
    'Give each layer time to settle.',
    'Skip one unnecessary experiment.',
    'Use lukewarm water tonight.',
    'Press toner in gently.',
    'Keep the routine under five steps.',
    'Apply sunscreen before the first scroll.',
    'Write down how your skin feels today.'
  ];

  var scratchHints = [
    { max: 15, text: 'The silver is starting to give.' },
    { max: 35, text: 'A little more — the pull is still hiding.' },
    { max: 55, text: 'Your ticket is waking up.' },
    { max: 68, text: 'Almost there.' },
    { max: 100, text: 'Opening the skin fortune.' }
  ];

  var rewardTiers = [
    { tier: 'skin-note', label: 'Skin Note', reward: '+5 XP', xp: 5, weight: 55, burst: false },
    { tier: 'routine-mission', label: 'Routine Mission', reward: '+10 XP', xp: 10, weight: 25, burst: true },
    { tier: 'sample-unlock', label: 'Sample Unlock', reward: '+20 XP', xp: 20, weight: 12, burst: true, claim: true },
    { tier: 'lucky-5', label: 'Lucky 5', reward: '+50 XP', xp: 50, weight: 6, burst: true },
    { tier: 'lucky-10', label: 'Lucky 10', reward: '+100 XP', xp: 100, weight: 1.8, burst: true },
    { tier: 'blue-moon', label: 'Blue Moon', reward: 'Blue Moon XP', xp: 300, weight: 0.2, burst: true, claim: true }
  ];

  roots.forEach(init);

  function init(root) {
    var canvas = root.querySelector('[data-scratch-canvas]');
    var wrap = root.querySelector('[data-scratch-wrap]');
    if (!canvas || !wrap) return;

    var state = {
      root: root,
      canvas: canvas,
      ctx: canvas.getContext('2d', { willReadFrequently: true }),
      wrap: wrap,
      customerKey: root.getAttribute('data-customer-key') || 'guest',
      today: todayKey(),
      pendingResult: null,
      pendingStreak: 1,
      scratchScore: 0,
      drawing: false,
      opened: false,
      emittedBuckets: {},
      lastPoint: null,
      foilImage: null,
      reducedMotion: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    };

    state.storageKey = STORAGE_PREFIX + ':streak:' + state.customerKey;
    state.playKey = STORAGE_PREFIX + ':play:' + state.customerKey + ':' + state.today;
    state.streak = readStreak(state.storageKey);
    state.pendingStreak = getPendingStreak(state.streak, state.today);

    root.__klairsSkinFortuneV5 = {
      reset: function () {
        localStorage.removeItem(state.playKey);
        setRootState(root, 'sealed');
        updateStreakBadge(state, false);
        resetScratch(state);
      },
      reveal: function () {
        beginOpening(state);
      }
    };

    updateDate(root, state.today);
    updateCountdown(root);
    setInterval(function () { updateCountdown(root); }, 60000);
    updateStreakBadge(state, false);
    bindControls(state);
    loadFoil(state);
    resizeCanvas(state);
    window.addEventListener('resize', function () { resizeCanvas(state); });

    var stored = safeJSON(localStorage.getItem(state.playKey));
    if (stored && stored.result) {
      renderLocked(state, stored.result);
    } else {
      setRootState(root, 'sealed');
      setStageCopy(root, state.pendingStreak > 1 ? 'Don’t break your ' + state.streak.streakCount + '-day streak.' : 'Start when you are ready.');
    }

    emit(root, 'view', { state: rootState(root), streak: state.streak.streakCount || 0 });
  }

  function bindControls(state) {
    var root = state.root;
    var start = root.querySelector('[data-start-button]');
    var finish = root.querySelector('[data-finish-button]');
    var tomorrow = root.querySelector('[data-tomorrow-button]');
    var shop = root.querySelector('[data-shop-link]');
    var claim = root.querySelector('[data-claim-link]');
    var save = root.querySelector('[data-save-note]');

    if (start) {
      start.addEventListener('click', function () {
        armTicket(state);
      });
    }

    if (finish) {
      finish.addEventListener('click', function () {
        if (state.opened) return;
        emit(root, 'finish_scratch', { percent: currentScratchPercent(state) });
        beginOpening(state);
      });
    }

    if (tomorrow) {
      tomorrow.addEventListener('click', function () {
        updateCountdown(root);
        tomorrow.blur();
      });
    }

    if (shop) {
      shop.addEventListener('click', function () {
        emit(root, 'shop_click', { tier: root.getAttribute('data-tier') || 'unknown' });
      });
    }

    if (claim) {
      claim.addEventListener('click', function () {
        emit(root, 'claim_click', { tier: root.getAttribute('data-tier') || 'unknown' });
      });
    }

    if (save) {
      save.addEventListener('click', function () {
        save.classList.add('is-saved');
        save.textContent = 'Saved for today';
        emit(root, 'save_note', { tier: root.getAttribute('data-tier') || 'unknown' });
      });
    }

    state.canvas.addEventListener('mousedown', function (event) { startScratch(state, event); });
    state.canvas.addEventListener('mousemove', function (event) { moveScratch(state, event); });
    window.addEventListener('mouseup', function () { stopScratch(state); });
    state.canvas.addEventListener('touchstart', function (event) { startScratch(state, event); }, { passive: false });
    state.canvas.addEventListener('touchmove', function (event) { moveScratch(state, event); }, { passive: false });
    state.canvas.addEventListener('touchend', function () { stopScratch(state); });
  }

  function armTicket(state) {
    if (state.opened) return;
    setRootState(state.root, 'armed');
    setTicketState(state.root, 'ARMED');
    setStageCopy(state.root, 'Scratch slowly.');
    state.root.querySelector('[data-scratch-hint]').textContent = scratchHints[0].text;
    emit(state.root, 'start', { streak_target: state.pendingStreak });
    vibrate(18);
  }

  function startScratch(state, event) {
    if (state.opened) return;
    if (!state.root.classList.contains('is-armed')) armTicket(state);
    event.preventDefault();
    state.drawing = true;
    state.lastPoint = pointerPosition(state, event);
    setRootState(state.root, 'scratching');
    drawScratch(state, state.lastPoint, state.lastPoint);
    emit(state.root, 'scratch_start', {});
  }

  function moveScratch(state, event) {
    if (!state.drawing || state.opened) return;
    event.preventDefault();
    var point = pointerPosition(state, event);
    drawScratch(state, state.lastPoint || point, point);
    state.lastPoint = point;
    var percent = currentScratchPercent(state);
    updateScratchUI(state, percent);
    if (percent >= REVEAL_THRESHOLD) beginOpening(state);
  }

  function stopScratch(state) {
    state.drawing = false;
    state.lastPoint = null;
  }

  function beginOpening(state) {
    if (state.opened) return;
    state.opened = true;
    state.pendingResult = state.pendingResult || createResult(state.pendingStreak);
    state.root.classList.remove('is-scratching');
    state.root.classList.add('is-near-reveal');
    setRootState(state.root, 'opening');
    setTicketState(state.root, 'OPENING');
    setStageCopy(state.root, 'Almost there.');
    emit(state.root, 'opening', { percent: Math.round(currentScratchPercent(state)) });
    vibrate([24, 34, 24]);

    window.setTimeout(function () {
      reveal(state, state.pendingResult);
    }, state.reducedMotion ? 90 : 720);
  }

  function reveal(state, result) {
    var root = state.root;
    var newStreak = {
      lastPlayDate: state.today,
      streakCount: state.pendingStreak,
      longestStreak: Math.max(state.pendingStreak, state.streak.longestStreak || 0)
    };

    renderResult(root, result, false);
    localStorage.setItem(state.storageKey, JSON.stringify(newStreak));
    localStorage.setItem(state.playKey, JSON.stringify({
      date: state.today,
      result: result,
      streakCount: newStreak.streakCount
    }));

    state.streak = newStreak;
    updateStreakBadge(state, true);
    setRootState(root, 'revealed');
    setTicketState(root, result.label.toUpperCase());
    setStageCopy(root, 'Today’s pull is open.');
    root.setAttribute('data-tier', result.tier);

    if (result.burst) createBurst(root, result.tier === 'blue-moon' ? 34 : 20);

    emit(root, 'reveal', { tier: result.tier, xp: result.xp, streak: newStreak.streakCount });
    emit(root, 'reward_tier', { tier: result.tier, xp: result.xp });
    emit(root, 'streak_day', { streak: newStreak.streakCount, longest: newStreak.longestStreak });
  }

  function renderLocked(state, result) {
    renderResult(state.root, result, true);
    state.root.setAttribute('data-tier', result.tier || 'skin-note');
    setRootState(state.root, 'locked');
    setTicketState(state.root, 'OPENED');
    setStageCopy(state.root, 'Today’s pull is already open.');
    updateCountdown(state.root);
    updateStreakBadge(state, false);
    emit(state.root, 'return_locked', { tier: result.tier || 'unknown', streak: state.streak.streakCount || 0 });
  }

  function renderResult(root, result, locked) {
    setText(root, '[data-result-tier]', result.label || 'Skin Note');
    setText(root, '[data-result-xp]', result.reward || '+5 XP');
    setText(root, '[data-skin-sign]', result.skinSign || 'The Reset');
    setText(root, '[data-care-sign]', result.careSign || 'Layer lightly today.');
    setText(root, '[data-reward-label]', result.reward || '+5 XP');
    setText(root, '[data-fortune-text]', result.fortune || 'Today favors doing less.');
    setText(root, '[data-mission-text]', 'Mission: ' + (result.mission || 'Add one hydration layer today.'));
    setText(root, '[data-xp-note]', xpNote(result, locked));
    setText(root, '[data-streak-gain]', locked ? 'Today’s streak is saved.' : '🔥 streak +1');
  }

  function createResult(pendingStreak) {
    var reward = pickReward(pendingStreak);
    var bonusXP = pendingStreak >= 7 ? 25 : 0;
    var result = {
      date: todayKey(),
      tier: reward.tier,
      label: reward.label,
      reward: reward.reward,
      xp: reward.xp + bonusXP,
      claim: !!reward.claim,
      skinSign: pick(skinSigns),
      careSign: pick(careSigns),
      fortune: pick(fortunes),
      mission: pick(missions),
      burst: reward.burst,
      streakBonusXP: bonusXP
    };
    if (bonusXP) result.reward = '+' + result.xp + ' XP';
    return result;
  }

  function pickReward(pendingStreak) {
    var weighted = rewardTiers.map(function (item) {
      var clone = {};
      Object.keys(item).forEach(function (key) { clone[key] = item[key]; });
      if (pendingStreak >= 3 && (clone.tier === 'sample-unlock' || clone.tier === 'routine-mission')) clone.weight *= 1.18;
      if (pendingStreak >= 7 && clone.tier === 'skin-note') clone.weight *= 0.72;
      if (pendingStreak >= 30 && (clone.tier === 'blue-moon' || clone.tier === 'lucky-10')) clone.weight *= 3.5;
      return clone;
    });
    var total = weighted.reduce(function (sum, item) { return sum + item.weight; }, 0);
    var roll = Math.random() * total;
    for (var i = 0; i < weighted.length; i += 1) {
      roll -= weighted[i].weight;
      if (roll <= 0) return weighted[i];
    }
    return weighted[0];
  }

  function loadFoil(state) {
    var url = state.canvas.getAttribute('data-foil-url');
    if (!url) return;
    var img = new Image();
    img.onload = function () {
      state.foilImage = img;
      resizeCanvas(state);
    };
    img.src = url;
  }

  function resizeCanvas(state) {
    var rect = state.wrap.getBoundingClientRect();
    var ratio = window.devicePixelRatio || 1;
    state.canvas.width = Math.max(1, Math.floor(rect.width * ratio));
    state.canvas.height = Math.max(1, Math.floor(rect.height * ratio));
    state.canvas.style.width = rect.width + 'px';
    state.canvas.style.height = rect.height + 'px';
    state.ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    drawCover(state, rect.width, rect.height);
  }

  function resetScratch(state) {
    state.opened = false;
    state.pendingResult = null;
    state.emittedBuckets = {};
    state.scratchScore = 0;
    state.pendingStreak = getPendingStreak(state.streak, state.today);
    resizeCanvas(state);
    updateScratchUI(state, 0);
    setTicketState(state.root, 'SEALED');
    setStageCopy(state.root, 'Start when you are ready.');
  }

  function drawCover(state, width, height) {
    var ctx = state.ctx;
    ctx.globalCompositeOperation = 'source-over';
    ctx.globalAlpha = 1;
    ctx.clearRect(0, 0, width, height);

    var gradient = ctx.createLinearGradient(0, 0, width, height);
    gradient.addColorStop(0, '#c9d8e8');
    gradient.addColorStop(0.28, '#f7fbff');
    gradient.addColorStop(0.56, '#bdd2e7');
    gradient.addColorStop(1, '#f8fbff');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);

    if (state.foilImage && state.foilImage.complete) {
      ctx.globalAlpha = 0.48;
      var pattern = ctx.createPattern(state.foilImage, 'repeat');
      if (pattern) {
        ctx.fillStyle = pattern;
        ctx.fillRect(0, 0, width, height);
      }
      ctx.globalAlpha = 1;
    }

    ctx.fillStyle = 'rgba(255, 255, 255, 0.26)';
    for (var i = -height; i < width; i += 62) {
      ctx.save();
      ctx.translate(i, 0);
      ctx.rotate(-0.36);
      ctx.fillRect(0, 0, 18, height * 2);
      ctx.restore();
    }

    ctx.fillStyle = 'rgba(20, 95, 210, 0.1)';
    ctx.font = '800 11px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText('SCRATCH SLOWLY', width / 2, height / 2);
  }

  function drawScratch(state, from, to) {
    var ctx = state.ctx;
    var brush = Math.max(28, Math.min(44, state.canvas.clientWidth * 0.095));
    var distance = Math.hypot(to.x - from.x, to.y - from.y);
    state.scratchScore += Math.max(brush * 0.7, distance * brush * 1.32);
    ctx.save();
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.lineWidth = brush;
    ctx.beginPath();
    ctx.moveTo(from.x, from.y);
    ctx.lineTo(to.x, to.y);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(to.x, to.y, brush * 0.42, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
    if (!state.reducedMotion) spawnScratchParticle(state, to);
  }

  function spawnScratchParticle(state, point) {
    if (Math.random() > 0.38) return;
    var particle = document.createElement('span');
    particle.className = 'ksf-v5__scratch-speck';
    particle.style.left = point.x + 'px';
    particle.style.top = point.y + 'px';
    particle.style.setProperty('--dx', (Math.random() * 34 - 17) + 'px');
    particle.style.setProperty('--dy', (-12 - Math.random() * 24) + 'px');
    state.wrap.appendChild(particle);
    window.setTimeout(function () { particle.remove(); }, 700);
  }

  function currentScratchPercent(state) {
    var ctx = state.ctx;
    var canvas = state.canvas;
    var pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    var clear = 0;
    for (var i = 3; i < pixels.length; i += 4) {
      if (pixels[i] < 24) clear += 1;
    }
    var pixelPercent = clear / (pixels.length / 4) * 100;
    var area = Math.max(1, state.canvas.clientWidth * state.canvas.clientHeight);
    var pathPercent = Math.min(100, state.scratchScore / (area * 0.62) * 100);
    return Math.max(pixelPercent, pathPercent);
  }

  function updateScratchUI(state, percent) {
    var root = state.root;
    var meter = root.querySelector('[data-seal-meter]');
    var hint = root.querySelector('[data-scratch-hint]');
    if (meter) meter.style.width = Math.min(100, percent / REVEAL_THRESHOLD * 100) + '%';
    if (hint) hint.textContent = hintFor(percent);
    root.classList.toggle('is-near-reveal', percent >= 56);

    progressBuckets.forEach(function (bucket) {
      if (percent >= bucket && !state.emittedBuckets[bucket]) {
        state.emittedBuckets[bucket] = true;
        emit(root, 'scratch_progress', { bucket: bucket, percent: Math.round(percent) });
      }
    });
  }

  function pointerPosition(state, event) {
    var point = event.touches ? event.touches[0] : event;
    var rect = state.canvas.getBoundingClientRect();
    return {
      x: Math.max(0, Math.min(rect.width, point.clientX - rect.left)),
      y: Math.max(0, Math.min(rect.height, point.clientY - rect.top))
    };
  }

  function setRootState(root, state) {
    ['sealed', 'armed', 'scratching', 'opening', 'revealed', 'locked'].forEach(function (name) {
      root.classList.toggle('is-' + name, name === state);
    });
  }

  function rootState(root) {
    var states = ['sealed', 'armed', 'scratching', 'opening', 'revealed', 'locked'];
    for (var i = 0; i < states.length; i += 1) {
      if (root.classList.contains('is-' + states[i])) return states[i];
    }
    return 'sealed';
  }

  function updateStreakBadge(state, animate) {
    var root = state.root;
    var playedToday = state.streak && state.streak.lastPlayDate === state.today;
    var continuedFromYesterday = state.streak && isYesterday(state.streak.lastPlayDate, state.today);
    var shown = playedToday
      ? state.streak.streakCount
      : (continuedFromYesterday ? state.streak.streakCount : 0);
    var rootStateName = rootState(root);
    var ticketText;
    var topStrong;
    var topLabel = 'skin streak';
    var aria;

    if (playedToday) {
      ticketText = '🔥 ' + state.streak.streakCount + '-day streak';
      if (rootStateName === 'locked') ticketText += ' · next ticket in ' + countdownShort();
      topStrong = state.streak.streakCount + '-day';
      aria = state.streak.streakCount + ' day streak';
    } else if (continuedFromYesterday && shown > 0) {
      ticketText = '🔥 ' + shown + '-day streak — don’t break it today.';
      topStrong = shown + '-day';
      aria = shown + ' day streak, do not break it today';
    } else {
      ticketText = '🔥 Start your streak today';
      topStrong = 'Start';
      topLabel = 'your streak today';
      aria = 'Start your streak today';
    }

    setText(root, '[data-streak-count]', topStrong);
    var topBadge = root.querySelector('[data-streak-badge] span:last-child');
    if (topBadge) topBadge.textContent = topLabel;
    var ticket = root.querySelector('[data-ticket-streak]');
    if (ticket) {
      ticket.textContent = ticketText;
      ticket.setAttribute('aria-label', aria);
    }
    setText(root, '[data-streak-milestone]', milestoneText(playedToday ? state.streak.streakCount : state.pendingStreak));
    var gain = root.querySelector('[data-streak-gain]');
    if (gain) gain.textContent = animate ? '🔥 ' + state.streak.streakCount + '-day skin streak' : 'Today’s streak is saved.';
  }

  function readStreak(key) {
    var parsed = safeJSON(localStorage.getItem(key)) || {};
    return {
      lastPlayDate: parsed.lastPlayDate || '',
      streakCount: Number(parsed.streakCount || 0),
      longestStreak: Number(parsed.longestStreak || 0)
    };
  }

  function getPendingStreak(streak, today) {
    if (streak.lastPlayDate === today) return streak.streakCount || 1;
    if (isYesterday(streak.lastPlayDate, today)) return (streak.streakCount || 0) + 1;
    if (streak.lastPlayDate && !isYesterday(streak.lastPlayDate, today)) {
      return 1;
    }
    return 1;
  }

  function isYesterday(dateKey, today) {
    if (!dateKey) return false;
    return dateDiff(dateKey, today) === 1;
  }

  function dateDiff(fromKey, toKey) {
    var from = localDate(fromKey);
    var to = localDate(toKey);
    if (!from || !to) return 999;
    return Math.round((to.getTime() - from.getTime()) / 86400000);
  }

  function localDate(key) {
    var parts = String(key || '').split('-').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) return null;
    return new Date(parts[0], parts[1] - 1, parts[2]);
  }

  function updateDate(root, key) {
    setText(root, '[data-ticket-date]', key.replace(/-/g, '.'));
  }

  function updateCountdown(root) {
    var node = root.querySelector('[data-reset-countdown]');
    var short = countdownShort();
    if (node) node.textContent = 'resets in ' + short;
    if (root.classList.contains('is-locked')) {
      var ticket = root.querySelector('[data-ticket-streak]');
      var count = root.querySelector('[data-streak-count]') ? root.querySelector('[data-streak-count]').textContent : '';
      if (ticket && count) ticket.textContent = '🔥 ' + count + ' streak · next ticket in ' + short;
    }
  }

  function countdownShort() {
    var now = new Date();
    var end = new Date(now);
    end.setHours(24, 0, 0, 0);
    var diff = Math.max(0, end.getTime() - now.getTime());
    var hours = Math.floor(diff / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    return hours + 'h ' + String(minutes).padStart(2, '0') + 'm';
  }

  function milestoneText(streak) {
    if (streak >= 30) return 'Blue Moon path is warmer at 30 days.';
    if (streak >= 7) return '7-day streak adds an XP boost.';
    if (streak >= 3) return '3-day streak warms the sample path.';
    return '3 days unlocks a softer reward path.';
  }

  function hintFor(percent) {
    for (var i = 0; i < scratchHints.length; i += 1) {
      if (percent <= scratchHints[i].max) return scratchHints[i].text;
    }
    return scratchHints[scratchHints.length - 1].text;
  }

  function xpNote(result, locked) {
    var base = (locked ? 'Already opened today. ' : '') + 'Glow Path XP display: ' + (result.reward || '+5 XP') + '.';
    if (result.streakBonusXP) base += ' Includes a 7-day streak boost.';
    if (result.claim) base += ' Log in to claim real rewards when Phase 3 is connected.';
    return base + ' Prototype only; server ledger integration is Phase 3.';
  }

  function createBurst(root, count) {
    var old = root.querySelector('.ksf-v5__burst');
    if (old) old.remove();
    var burst = document.createElement('div');
    burst.className = 'ksf-v5__burst';
    for (var i = 0; i < count; i += 1) {
      var particle = document.createElement('span');
      particle.className = 'ksf-v5__particle';
      var angle = Math.random() * Math.PI * 2;
      var distance = 120 + Math.random() * 170;
      particle.style.setProperty('--x', Math.cos(angle) * distance + 'px');
      particle.style.setProperty('--y', Math.sin(angle) * distance + 'px');
      particle.style.animationDelay = Math.random() * 160 + 'ms';
      burst.appendChild(particle);
    }
    root.querySelector('[data-ticket]').appendChild(burst);
    window.setTimeout(function () { burst.remove(); }, 1500);
  }

  function setTicketState(root, text) {
    setText(root, '[data-ticket-state]', text);
  }

  function setStageCopy(root, text) {
    setText(root, '[data-stage-copy]', text);
  }

  function setText(root, selector, text) {
    var node = root.querySelector(selector);
    if (node) node.textContent = text;
  }

  function todayKey() {
    var now = new Date();
    return now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
  }

  function pick(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function safeJSON(value) {
    try {
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function emit(root, name, payload) {
    var eventName = name.indexOf('skin_fortune_') === 0 ? name : 'skin_fortune_' + name;
    var data = payload || {};
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(Object.assign({ event: eventName }, data));
    }
    root.dispatchEvent(new CustomEvent(eventName, { detail: data }));
  }

  function suppressRewardOverlays() {
    [
      '#Avada-Joy_FloatingButton',
      '.Avada-Preview__ReferralCard',
      '.Avada-Joy_ButtonWidget',
      '.joy-points-calculator__block--embed'
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('visibility', 'hidden', 'important');
        node.style.setProperty('pointer-events', 'none', 'important');
      });
    });
  }

  function vibrate(pattern) {
    if (navigator.vibrate) navigator.vibrate(pattern);
  }
})();
